(() => {
  if (typeof window.customElements.get('featured-collections') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'featured-collections',
    class FeaturedCollections extends HTMLElement {
      constructor() {
        super();

        this.navItems = this.querySelectorAll('[data-featured-collections-nav-item]');
        this.collectionBlocks = this.querySelectorAll('[data-featured-collections-block]');
        this.carousels = this.querySelectorAll('[data-featured-collections-carousel]');

        this.initFeaturedCollections();
      }

      initFeaturedCollections() {
        try {
          this.setupNavigation();
          this.setupSwipers();
        } catch (error) {
          console.error('There was a problem with the FeaturedCollections component:', error);
        }
      }

      setupNavigation() {
        if (this.navItems.length < 1) {
          return;
        }

        this.navItems.forEach((navItem) => {
          navItem.addEventListener('click', () => {
            const blockId = navItem.getAttribute('data-featured-collections-nav-item');
            this.switchToBlock(blockId);
          });

          navItem.addEventListener('keydown', (e) => {
            const currentIndex = Array.from(this.navItems).indexOf(navItem);
            let targetIndex = currentIndex;

            switch (e.key) {
              case 'ArrowLeft':
                e.preventDefault();
                targetIndex = currentIndex > 0 ? currentIndex - 1 : this.navItems.length - 1;
                break;
              case 'ArrowRight':
                e.preventDefault();
                targetIndex = currentIndex < this.navItems.length - 1 ? currentIndex + 1 : 0;
                break;
              case 'Home':
                e.preventDefault();
                targetIndex = 0;
                break;
              case 'End':
                e.preventDefault();
                targetIndex = this.navItems.length - 1;
                break;
              default:
                return;
            }

            if (targetIndex !== currentIndex) {
              const targetBlockId = this.navItems[targetIndex].getAttribute('data-featured-collections-nav-item');
              this.switchToBlock(targetBlockId);
              this.navItems[targetIndex].focus();
            }
          });
        });
      }

      switchToBlock(blockId) {
        this.navItems.forEach((navItem) => {
          const isActive = navItem.getAttribute('data-featured-collections-nav-item') === blockId;
          navItem.classList.toggle('active', isActive);
          navItem.setAttribute('aria-selected', isActive ? 'true' : 'false');
          navItem.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.collectionBlocks.forEach((block) => {
          const isActive = block.getAttribute('data-featured-collections-block') === blockId;
          block.classList.toggle('active', isActive);
          if (isActive) {
            block.removeAttribute('hidden');
          } else {
            block.setAttribute('hidden', '');
          }
        });
      }

      setupSwipers() {
        if (this.carousels.length < 1) {
          return;
        }

        this.carousels.forEach((carousel) => {
          const prevButton = carousel.querySelector('[data-featured-collections-carousel-prev]');
          const nextButton = carousel.querySelector('[data-featured-collections-carousel-next]');
          const collectionSwiper = new Swiper(carousel, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            centeredSlides: false,
            loop: true,
            mousewheel: {
              enabled: true,
              forceToAxis: true,
            },
            navigation: {
              nextEl: nextButton,
              prevEl: prevButton,
            },
          });

          return collectionSwiper;
        });
      }
    }
  );
})();
